import * as React from "react";
import { LocaleUtils } from "@grandvisionhq/utils";
import { useCookieConsentContext } from "../../context/context/CookieConsentContext.js";
import { isCookieCategoryEnabled } from "../../provider/provider/onetrust-provider.js";
import { shouldBypassConsent } from "../../utils/utils/debug.js";
function OneTrustCookieConsent(props) {
  const { locale, isMultilingual, src, domain, skipScriptAfterConsent, ScriptComponent } = props;
  const [selectedLocale, setSelectedLocale] = React.useState("");
  const consentResult = useCookieConsentContext();
  React.useEffect(() => {
    if (isMultilingual) {
      const cookieLocale = LocaleUtils.getLocaleFromCookie()?.toLowerCase();
      if (cookieLocale) {
        const urlLocale = LocaleUtils.getLocaleFromUrl(window.location.href);
        if (urlLocale && cookieLocale !== urlLocale) {
          LocaleUtils.setLocaleToCookie(urlLocale);
          setSelectedLocale(urlLocale);
        } else {
          setSelectedLocale(cookieLocale);
        }
      } else {
        const urlLocale = LocaleUtils.getLocaleFromUrl(window.location.href);
        if (urlLocale) {
          LocaleUtils.setLocaleToCookie(urlLocale);
          setSelectedLocale(urlLocale);
        }
      }
    } else {
      setSelectedLocale(locale);
    }
  }, [locale, isMultilingual]);
  if (shouldBypassConsent()) {
    return null;
  }
  if (skipScriptAfterConsent && isCookieCategoryEnabled("required", consentResult)) {
    return null;
  }
  if (!src || !domain) {
    console.error(`Unable to initiate OneTrust with {${JSON.stringify({ src, domain })}}`);
    return null;
  }
  if (!selectedLocale) return null;
  const [language] = selectedLocale.split("-");
  const scriptProps = {
    src,
    type: "text/javascript",
    charSet: "UTF-8",
    crossOrigin: "anonymous",
    "data-language": language,
    "data-domain-script": domain
  };
  return ScriptComponent ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ScriptComponent, { ...scriptProps }), /* @__PURE__ */ React.createElement(ScriptComponent, null, "function OptanonWrapper() {}")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("script", { ...scriptProps }), /* @__PURE__ */ React.createElement("script", { type: "text/javascript" }, "function OptanonWrapper() {}"));
}
export {
  OneTrustCookieConsent
};
//# sourceMappingURL=onetrust-cookie-consent.js.map
